/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Roles from './roles';
import RolesDetail from './roles-detail';
import RolesUpdate from './roles-update';
import RolesDeleteDialog from './roles-delete-dialog';

const RolesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Roles />} />
    <Route path="new" element={<RolesUpdate />} />
    <Route path=":id">
      <Route index element={<RolesDetail />} />
      <Route path="edit" element={<RolesUpdate />} />
      <Route path="delete" element={<RolesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RolesRoutes;
